import { ToastClassInterface } from './types';

export enum ToastSeverity {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info',
}

export const toastAlertClass: ToastClassInterface = {
  success: '!bg-slime-25 !border-slime-300',
  error: '!bg-red-25 !border-red-300',
  warning: '!bg-yellow-25 !border-yellow-300',
  info: '!bg-primary-25 !border-primary-300',
};

export const toastIconClass: ToastClassInterface = {
  success: 'hover:bg-slime-100 active:bg-slime-200',
  error: 'hover:bg-red-100 active:bg-red-200',
  warning: 'hover:bg-yellow-100 active:bg-yellow-200',
  info: 'hover:bg-primary-100 active:bg-primary-200',
};

export const toastMessageClass: ToastClassInterface = {
  success: '!text-slime-700',
  error: '!text-red-700',
  warning: '!text-yellow-700',
  info: '!text-primary-700',
};

export const toastDescriptionClass: ToastClassInterface = {
  success: '!text-slime-600',
  error: '!text-red-600',
  warning: '!text-yellow-600',
  info: '!text-primary-600',
};
